import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { VaultSideNavService } from '@app/modules/vault/container/vault.side-nav.service';
import { RootStoreState, vaultStoreActions } from '@app/root-store';
import { AuthService, CommonService, DocumentService } from '@app/shared/services';
import { Store, select } from '@ngrx/store';
import { Subscription } from 'rxjs';

import * as selectors from '../../../../root-store/vault-store/vault.selector';
import * as loginSelectors from '../../../../root-store/login-store/login.selector';
import { AddDocumentComponent } from '@app/modules/vault/components/add-document/add-document.component';
import { MatDialog } from '@angular/material/dialog';
import { LoginStoreEffects } from '@app/root-store/login-store/effects';
import { VaultStoreEffects } from '@app/root-store/vault-store/effects';
//
import { fetchUserAttributes } from '@aws-amplify/auth';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'checklist-shortcut-add',
  templateUrl: './checklist-shortcut-add.component.html',
  styleUrl: './checklist-shortcut-add.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChecklistShortcutAddComponent implements OnInit, OnDestroy {
  @Output() selectVaultEvent = new EventEmitter<any>();
  @Output() backClick = new EventEmitter<void>();
  @Input() folderId;
  @Input() subFolderId;
  @Input() userId;
  @Input() from;
  @Input() folderName;
  @Input() nameForm = '';
  @Input() type;
  @Input() templatetype;
  @Input() typeLocation;
  @Input() parentVaultLocationId;
  @Input() selectedTemplate;
  vaultItems = [];
  navCount = 0;
  vaults;
  stateObject;

  searchedStr = '';
  templates: any;
  allTemplate: any;
  organization_group: string;

  shortedByAZ = true;

  section: any;
  folder: any;

  vaultStateObject$: any;
  vaultStateObject;
  defaultFolders;
  getAllForms = [];
  @Input() is_filter = '';
  steps: any;

  vault_step_1 = true;
  vault_step_2 = false;
  is_filter_name = false;

  loginStateObject;

  formsList;
  subscription: Subscription = new Subscription();
  isImpersonating = true;
  switchFromUser = false;

  constructor(
    private cd: ChangeDetectorRef,
    private commonService: CommonService,
    private store$: Store<RootStoreState.State>,
    private vaultService: VaultStoreEffects,
    private documentService: DocumentService,
    private loginService: LoginStoreEffects,
    private dialog: MatDialog,
    private store: Store,
    private sideNavService: VaultSideNavService,
    private authService: AuthService
  ) {
    this.subscription.add(
      this.loginService.loginObject.subscribe(async (state) => {
        this.loginStateObject = state.data;
        const authUser = this.authService.user;
        if (this.loginStateObject?.switch_from_user_id && this.loginStateObject?.id != authUser['id']) {
          this.switchFromUser = this.loginStateObject?.switchFromUser;
        }
        this.cd.detectChanges();
      })
    );

    this.subscription.add(
      this.vaultService.vaultObject.subscribe((state) => {
        this.formsList = state?.forms ? state?.forms : [];
      })
    );
    this.subscription.add(
      this.store.pipe(select(loginSelectors.getCurrentUserFullDetails)).subscribe((result) => {
        if (result) {
          this.stateObject = result;
        } else {
          this.stateObject = null;
        }
      })
    );

    this.subscription.add(
      this.store.pipe(select(selectors.getVaultItems('Last Updated'))).subscribe((item) => {
        if (item) {
          const tempEllemt = item.map((element) => ({
            ...element,
            name: element.name ?? element.vault_name,
          }));
          this.vaultItems = [...tempEllemt];
        }
        this.cd.detectChanges();
      })
    );
  }

  ngOnInit(): void {
    console.warn(
      '🚀 ~ RegisterTemplateComponent ~ ngOnInit ~ from:',
      this.from,
      this.nameForm,
      this.is_filter,
      this.folderId,
      this.subFolderId,
      this.userId
    );

    this.vaults = this.vaultItems;
    if (this.from == 'group') {
      this.subscription.add(
        this.documentService.getFolderHierarchy(this.userId, this.subFolderId ?? this.folderId).subscribe((response) => {
          if (response.status == 200) {
            let res = response.data;
            this.section = res[res.length - 1];
            // if(res.length > 1 ) this.folder =  res[0];
            this.subscription.add(
              this.store.pipe(select(selectors.getTemplateByFolderNav(this.section?.name))).subscribe((response) => {
                let uniqueNames = {};
                let uniqueObjects = response.filter((obj) => {
                  if (!uniqueNames[obj.organization_group]) {
                    uniqueNames[obj.organization_group] = true;
                    return true;
                  }
                  return false;
                });
                uniqueObjects.unshift({ organization_group: 'All Templates' });
                this.steps = uniqueObjects;
                if (this.nameForm && this.steps.some((obj) => obj.organization_group === this.nameForm)) {
                  this.organization_group = this.nameForm;
                } else {
                  this.organization_group = 'All Templates';
                }
                this.getTemplate(this.organization_group);
                this.cd.detectChanges();
              })
            );
          }
        })
      );
    } else if (this.from == 'folder' && this.type != 'location') {
      this.subscription.add(
        this.store.pipe(select(selectors.getTemplateByFolderNav(this.folderName))).subscribe((response) => {
          let uniqueNames = {};
          let uniqueObjects = response.filter((obj) => {
            if (!uniqueNames[obj.organization_group]) {
              uniqueNames[obj.organization_group] = true;
              return true;
            }
            return false;
          });
          uniqueObjects.unshift({ organization_group: 'All Templates' });
          this.steps = uniqueObjects;
        })
      );
    } else if ((this.from == 'section' || this.from == 'vault') && this.type != 'location') {
      this.subscription.add(
        this.store.pipe(select(selectors.getTemplateBySectionNavShortcut())).subscribe((response) => {
          let uniqueNames = {};
          let uniqueObjects = response.filter((obj) => {
            if (!uniqueNames[obj.name]) {
              uniqueNames[obj.name] = true;
              return true;
            }
            return false;
          });
          if (this.is_filter == 'Liability') {
            uniqueObjects.unshift({ name: 'Liability Templates' });
          } else if (this.is_filter == 'Asset') {
            uniqueObjects.unshift({ name: 'Asset Templates' });
          } else {
            uniqueObjects.unshift({ name: 'All Templates' });
          }
          if (this.is_filter == 'Liability' || this.is_filter == 'Asset' || this.is_filter == 'Entity') {
            let newList = [];
            uniqueObjects.forEach((element) => {
              if (element.name == 'Liability Templates' || element.name == 'Asset Templates') {
                newList.push(element);
              } else {
                let filter_data_count = 0;
                let fullData = this.formsList.filter((it) => it.organization_section == element.name);
                if (this.is_filter == 'Liability') {
                  filter_data_count = fullData.filter((x) => x.is_liability).length;
                }
                if (this.is_filter == 'Asset') {
                  filter_data_count = fullData.filter((x) => x.is_asset).length;
                }
                if (this.is_filter == 'Entity') {
                  filter_data_count = fullData.filter((x) => x.type_template === 'Entity').length;
                }
                if (filter_data_count > 0) {
                  newList.push(element);
                }
              }
            });
            uniqueObjects = newList;
          }

          this.steps = uniqueObjects;
        })
      );
    }
    if (this.from != 'group') {
      if (this.nameForm) {
        this.organization_group = this.nameForm;
      } else {
        this.organization_group = 'All Templates';
        if (this.is_filter == 'Asset') {
          this.organization_group = 'Asset Templates';
        } else if (this.is_filter == 'Liability') {
          this.organization_group = 'Liability Templates';
        } else if (this.is_filter == 'Entity') {
          this.organization_group = 'Entities';
        }
      }
      this.getTemplate(this.organization_group);
      this.cd.detectChanges();
    }
  }

  onMouseEnter(template) {
    template.isHover = true;
    this.cd.detectChanges();
  }

  onMouseOut(template) {
    template.isHover = false;
    this.cd.detectChanges();
  }
  getTemplate(organization_group: string) {
    this.nameForm = organization_group;
    if (this.from == 'section' || this.from == 'vault') {
      this.organization_group = organization_group;
      this.subscription.add(
        this.store
          .pipe(
            select(
              selectors.getTemplateBySection(
                this.organization_group == 'Asset Templates' ||
                  this.organization_group == 'Liability Templates' ||
                  this.organization_group == 'All Templates'
                  ? 'All'
                  : this.organization_group,
                this.organization_group == 'All Templates' ||
                  this.organization_group == 'Asset Templates' ||
                  this.organization_group == 'Liability Templates'
                  ? true
                  : false
              )
            )
          )
          .subscribe((response) => {
            try {
              if (this.is_filter == 'Liability') {
                response = response.filter((x) => x.is_liability);
              }

              if (this.is_filter == 'Asset') {
                response = response.filter((x) => x.is_asset);
              }
            } catch (error) {}
            if (this.type == 'location') {
              this.allTemplate = response
                .filter((form) => form.onboarding_tags)
                .filter((form) => form.onboarding_tags.toLowerCase().includes(this.typeLocation.toLowerCase()))
                .map((obj) => {
                  return { ...obj, isHover: false };
                });
            } else {
              this.allTemplate = response.map((obj) => {
                return { ...obj, isHover: false };
              });
            }
            this.cd.detectChanges();
          })
      );
    } else if (this.from == 'folder') {
      this.organization_group = organization_group;
      this.subscription.add(
        this.store
          .pipe(
            select(
              selectors.getTemplateByFolder(
                this.organization_group == 'All Templates' ? this.folderName : this.organization_group,
                this.organization_group == 'All Templates' ? true : false
              )
            )
          )
          .subscribe((response) => {
            if (this.type == 'location') {
              this.allTemplate = response
                .filter((form) => form.onboarding_tags)
                .filter((form) => {
                  form.onboarding_tags.toLowerCase().includes(this.typeLocation.toLowerCase());
                })
                .map((obj) => {
                  return { ...obj, isHover: false };
                });
            } else {
              this.allTemplate = response.map((obj) => {
                return { ...obj, isHover: false };
              });
            }
            this.cd.detectChanges();
          })
      );
    } else if (this.from == 'group') {
      if (this.nameForm && this.steps.some((obj) => obj.organization_group === this.nameForm)) {
        this.organization_group = this.nameForm;
      } else {
        this.organization_group = 'All Templates';
      }
      this.subscription.add(
        this.store
          .pipe(
            select(
              selectors.getTemplateByCategory(
                this.organization_group == 'All Templates' ? this.folder?.name ?? this.section?.name : this.organization_group,
                this.organization_group == 'All Templates' ? true : false
              )
            )
          )
          .subscribe((response) => {
            if (this.type == 'location') {
              this.allTemplate = response
                .filter((form) => form.onboarding_tags)
                .filter((form) => form.onboarding_tags.toLowerCase().includes(this.typeLocation.toLowerCase()))
                .map((obj) => {
                  return { ...obj, isHover: false };
                });
            } else {
              this.allTemplate = response.map((obj) => {
                return { ...obj, isHover: false };
              });
            }
            this.cd.detectChanges();
          })
      );
    }
  }

  handleSteps() {
    this.vault_step_2 = false;
    this.vault_step_1 = true;
    this.cd.detectChanges();
  }

  searchVault(searchText) {
    this.searchedStr = searchText;
    let filteredVault = this.vaultItems
      .filter((vault) => vault.name.toLowerCase().includes(this.searchedStr.toLowerCase()))
      .map((item) => {
        return item;
      });
    this.vaults = [...new Set([...filteredVault])];
  }

  clearSearchAction() {
    this.searchedStr = '';
    this.getTemplate(this.organization_group);
  }

  shortByAlphabetic() {
    this.shortedByAZ = !this.shortedByAZ;
    if (this.shortedByAZ) {
      this.templates.sort((a, b) => a.type.localeCompare(b.type));
    } else {
      this.templates.sort((a, b) => b.type.localeCompare(a.type));
    }
    this.cd.detectChanges();
  }

  closeSideNav() {
    // this.organization_group = "All Templates"
    this.searchedStr = '';
    // this.commonService.locationTemplateDataSubject.next(undefined);
    // this.closingNavEmitter.emit(true);
    // this.vaultStateObject$ = this.vaultService.vaultObject;
    if (this.backClick) {
      this.backClick.emit();
    }
    this.commonService.toggleTemplateSidenav(false);
    this.cd.detectChanges();
  }

  openVaultTemplate(vault) {
    this.openSelectedTemplate(this.selectedTemplate, vault.id);
  }

  openSelectedTemplate(item, vaultId: number = null) {
    try {
      this.selectVaultEvent.next(vaultId);
    } catch (error) {}
    this.closeSideNav();
    let sharedUsers: any = [];
    let modalRef2;
    modalRef2 = this.dialog.open(AddDocumentComponent, {
      disableClose: true,
      data: {
        type_template: item.type,
        isintelligent: true,
        is_filter_name: this.type == 'location' ? 'Location' : '',
        parent_vault_user_location_id: this.parentVaultLocationId,
        form_id: item.id,
        folder_id: item.type,
        sharedUsers,
        mode: 'edit',
        vaultId: vaultId,
      },
      panelClass: 'full-window-dialog-add-document',
      autoFocus: false,
    });

    // this.closeSideNav();
    this.subscription.add(
      modalRef2.afterClosed().subscribe((result) => {
        this.closeSideNav();
      })
    );
  }

  addVAultDone(data) {
    this.store$.dispatch(new vaultStoreActions.GetVaultRequestAction(this.stateObject?.id, false));
    this.vaultItems.push(data);
    this.openVaultTemplate(data);
    this.cd.detectChanges();
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    this.closeSideNav();
  }
}
